import { render, staticRenderFns } from "./EmmaWidget.vue?vue&type=template&id=0c864993&"
import script from "./EmmaWidget.vue?vue&type=script&lang=ts&"
export * from "./EmmaWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports